// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"0deab11a","597":"7c37634e"}[chunkId] + ".chunk.css";
};